export const INITIAL_STATE = {
    account_drawer_layout: false,
    customer_invoicing: false,
    customers: false,
    ddm_connection: false,
    eavision: false,
    faa_reports: false,
    field_view: false,
    flight_groups: false,
    flight_log_list: false,
    incentive_program_ui: false,
    intercom_chat: false,
    john_deere: false,
    manage_connections: false,
    operator_map_tile: false,
    pdf_extraction: false,
    product_usage_report_delete: false,
    product_usage_report_edit: false,
    quickbooks: false,
    state_reporting: false,
    v2_reskin: false,
    v2_reskin_cutoff: false
};
